module.exports = __webpack_public_path__ + "img/event_detail.b51503cb.png";